import { Checkbox, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useMutation } from '@tanstack/react-query'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { queryClient } from '../../../../../App'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { formatAddress } from '../../../../../helpers/ordersUtiles'
import {
  isAdmin,
  isOperator,
  isSuperOperator,
} from '../../../../../services/AccountService'
import { maintenanceEditEquipmentData } from '../../../../../services/NewApiService'
import { getComp } from '../../../../../utils/utils/DI'

const ServiceInstallationData = ({
  defaultOpenState,
  serviceOrder,
  onEdit,
  setIsEdit,
  isEdit,
  serviceStore,
  withoutInstallationDate,
}) => {
  const intl = useIntl()
  const categoriesStore = getComp('CategoriesStore')

  const {
    equipmentId,
    created,
    territory,
    address,
    name,
    surname,
    patronymic,
    dealerName,
    additionalInfo,
    preferentialCategories,
    preferentialCategory,
    phoneNumber,
    installationReasonId,
    maintenanceReasonName,
    locality,
    district,
    house,
    building,
    apartment,
    addressType,
    status,
    isRepeatedAppeal,
    id,
    authorId,
    isCallCenterAuthor,
    serviceCenterComment,
  } = serviceOrder
  const [value, setValue] = useState(isRepeatedAppeal ?? false)
  const { mutateAsync: updateUrgentStatus, isPending } = useMutation(
    {
      mutationKey: ['update-service-equipment-data'],
      mutationFn: (body) => maintenanceEditEquipmentData(body),
      onSuccess(data) {
        serviceStore.updateOrders(data) // обновляем данные в таблице заявок

        if (isAdmin()) {
          queryClient.invalidateQueries({
            queryKey: ['service-table'],
          })
          queryClient.invalidateQueries({
            queryKey: ['get-request-linked-to-service'],
          })
          queryClient.invalidateQueries({
            queryKey: ['single-service-report-table'],
          })
          queryClient.invalidateQueries({
            queryKey: ['get-service-history'],
          })
          serviceStore?.updateCurrentServiceData?.(data)
        }
      },
    },
    queryClient,
  )

  const { showAddServiceRequestFormFunc } = serviceStore
  const handleEdit = () => {
    showAddServiceRequestFormFunc(serviceOrder, false, true)
    setIsEdit(!isEdit)
  }

  const getNormalizedString = (obj) => {
    return formatAddress(obj)
  }
  function formatPhoneNumber(phoneNumber) {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '')
    const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/)

    if (match) {
      return `+${match[1]} (${match[2]})-${match[3]}-${match[4]}-${match[5]}`
    }

    return null // Вернуть null, если входные данные некорректны
  }

  const isAuthor = getComp('UserInfoStore').userId === authorId
  const forbidEdit = isOperator() && !isSuperOperator() && !isAuthor
  const forbidSuperOperatorEdit = isSuperOperator() && !isCallCenterAuthor
  const isCorrectRole = isAdmin() || isOperator()

  const onChange = (_e, checked) => {
    if (forbidEdit || forbidSuperOperatorEdit || !isCorrectRole) {
      return
    }

    if (!isPending && [1, 2, 4, 20].includes(status)) {
      setValue(checked)
      updateUrgentStatus({
        orderId: id,
        isRepeatedAppeal: checked,
      })
    }
  }

  return (
    <CustomAccordion
      summary={
        isEdit
          ? intl.formatMessage({ id: 'Редактирование заявки' })
          : intl.formatMessage({ id: 'Данные абонента' })
      }
      defaultOpenState={defaultOpenState}
      onEdit={onEdit ? handleEdit : null}
    >
      <Box
        sx={{
          padding: '10px 0 0 14px',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        {/* <DataUnit name='Id оборудования' value={equipmentId} /> */}
        {!withoutInstallationDate && (
          <DataUnit
            name='Дата установки'
            value={moment(created).format('DD.MM.YYYY')}
          />
        )}
        {/* <DataUnit name='Регион' value={territory} /> */}
        <DataUnit
          name='Адрес'
          value={getNormalizedString({
            territory,
            district,
            locality,
            address,
            addressType,
            house,
            building,
            apartment,
          })}
        />
        <DataUnit
          name='Заказчик'
          value={`${surname || ''} ${name || ''} ${patronymic || ''}`}
        />
        <DataUnit name='Причина' value={maintenanceReasonName} />
        <DataUnit name='Телефон' value={formatPhoneNumber(phoneNumber)} />
        <DataUnit name='Дополнительная информация' value={additionalInfo} />
        {[20, 21, 24].includes(status) && (
          <DataUnit name='Комментарий для СЦ' value={serviceCenterComment} />
        )}
        <Box
          className={'fx-nowrap aln-center'}
          sx={{
            cursor: 'default',
            height: '100%',
          }}
        >
          <Checkbox
            sx={{ padding: '0 8px 0 0' }}
            checked={value}
            onChange={onChange}
          />
          <Typography
            variant={'body1'}
            sx={{
              whiteSpace: 'nowrap',
              fontWeight: '400',
            }}
          >
            Повторное обращение
          </Typography>
        </Box>
      </Box>
    </CustomAccordion>
  )
}

export default observer(ServiceInstallationData)
